<script lang="ts">
  import { onMount } from 'svelte'

  import LabelStudioIcon from '@components/LabelStudioIcon.svelte'
  import Link from '@components/Link.svelte'
  import { loggedInStore } from '@stores/logged-in-store'
  import { getLabelStudioConfig, type LabelStudioConfig } from '@utils/label-studio'

  let labelStudioEnabled = $state(false)

  onMount(async () => {
    const config: LabelStudioConfig = await getLabelStudioConfig()
    labelStudioEnabled = config.enabled
  })
</script>

<svelte:head>
  <title>Hirundo - Home</title>
  <meta name="description" content="Hirundo: This is the UI to manage Hirundo tools" />
</svelte:head>

<div class="mx-auto lg:text-center">
  <div class="grid w-full min-w-[90vw] gap-1 md:min-w-[70vw] md:grid-cols-[auto_1fr_auto]">
    <nav class="list-nav bg-primary-100 p-4 dark:bg-surface-500/30">
      <ul>
        <Link path="/api-keys" listIcon>API keys</Link>
        <Link path="/huggingface-tokens" listIcon>HuggingFace Tokens</Link>
        <Link path="/organizations" listIcon>Organizations</Link>
        <Link path="/user-associations" listIcon>User associations</Link>
        <Link path="/invitations" listIcon>Invitations</Link>
        {#if labelStudioEnabled}
          <Link path="/label-studio" listIcon newTab hideActive>
            <span class="inline-flex items-center gap-2">
              Label Studio
              <LabelStudioIcon />
            </span>
          </Link>
        {/if}
      </ul>
    </nav>
    <section class="bg-primary-50 p-4 dark:bg-surface-500/30">
      <h2 class="h2 mb-4 mt-2 font-medium tracking-tight">
        {$loggedInStore.fullName}, welcome to Hirundo!
      </h2>
      <p>Here is the place to manage your Hirundo account. Choose an item to Manage on the left</p>
    </section>
  </div>
</div>
